import { useEffect, useState } from "react";
import { isMobile } from "../utils/func";
import Button from "./Button";
import { useNavigate } from "react-router-dom";

export const MobileFloatingBtn = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobile()) return;

    const onScroll = () => {
      const threshold = window.innerHeight; //  "내 기기 height값" 기준
      setVisible(window.scrollY >= threshold);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!isMobile() || !visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      {/* 버튼 배경/여백(원하면 조정) */}
      <div className="flex flex-row gap-4 w-full py-6 px-4 bg-[#FFF] border-t-[1px] border-t-[#DDE0E6] shadow-[0_-2px_8px_rgba(0,0,0,0.05)]">
        <Button
          id="btn-floating-apply"
          onClick={() => {
            navigate("/inquiry-form?type=adoption");
          }}
          size="sm"
          className="flex-1 text-base font-medium"
        >
          도입문의
        </Button>
        <Button
          id="btn-floating-doc"
          size="sm"
          variant="ghost"
          className="flex-1 border-[1px] border-[#DDE0E6] text-base font-medium"
          onClick={() => {
            navigate("/inquiry-form?type=introduction");
          }}
        >
          소개서 신청
        </Button>
      </div>
    </div>
  );
};
